import * as Sentry from "@sentry/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { authenticate } from "@/api/api";
import { bannersPlacementsQueryOptions } from "@/hooks/useBannersPlacement";
import { growthbook } from "@/lib/growthbook";
import { CommonTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";
import { decode } from "@/utils/tokens";

export const Route = createFileRoute("/_authenticated")({
  component: RouteComponent,
  beforeLoad: async () => {
    const accessToken = await authenticate();

    const { userId } = decode(accessToken);
    Sentry.setUser({ id: userId });
    rudderAnalytics.identify(userId);
    growthbook.setAttributes({ id: userId });
  },
  loader: ({ context }) => {
    // Prefetch all placements in the background without blocking navigation
    void context.queryClient.prefetchQuery(bannersPlacementsQueryOptions());
  },
  onEnter: () => {
    rudderAnalytics.track(CommonTrackingEvents.USER_OPENED_APP);
  },
});

function RouteComponent() {
  return <Outlet />;
}
